import { render, staticRenderFns } from "./Blocklist.vue?vue&type=template&id=5ef00dfb&scoped=true&"
import script from "./Blocklist.vue?vue&type=script&lang=js&"
export * from "./Blocklist.vue?vue&type=script&lang=js&"
import style0 from "./Blocklist.vue?vue&type=style&index=0&id=5ef00dfb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef00dfb",
  null
  
)

export default component.exports